import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * `clsx` for the conditionals, `tailwind-merge` for the conflicts.
 *
 * Both halves are needed and they do different jobs. `clsx` flattens
 * `cn('p-2', isWide && 'w-full', { 'opacity-50': disabled })` into a string. `twMerge` then
 * resolves same-property collisions LAST-WINS — so a component's default `px-4` and a caller's
 * `px-8` produce `px-8` rather than both, which in raw CSS would be decided by whichever
 * Tailwind happened to emit first in the stylesheet.
 *
 * That last part is the reason this exists at all: without it, `className` on a design-system
 * component overrides its defaults *sometimes*, depending on Tailwind's internal class order,
 * and the failure looks like a caching bug.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
